export const sortSizes = function (obj) {
  if (obj.length === 0) {
    return {};
  }
  const arrOfArrays = Object.entries(obj);

  return arrOfArrays.sort((a, b) => {
    return a[1].localeCompare(b[1]);
  });
};

export const pushToArray = function (arr, obj) {
  const index = arr.findIndex((e) => e.id === obj.id);

  if (index === -1) {
    arr.push(obj);
  } else {
    arr[index] = obj;
  }
};

export const convertKeysToString = function (obj) {
  let keys = [];
  for (let key in obj) {
    keys.push(key.toString());
    if (typeof obj[key] === "object") {
      keys = keys.concat(convertKeysToString(obj[key]));
    }
  }
  return keys;
};

export const textCut = function (text, limit) {
  text = text.trim();
  if (text.length <= limit) return text;
  text = text.slice(0, limit);
  let lastSpace = text.lastIndexOf(" ");
  if (lastSpace > 0) {
    text = text.substr(0, lastSpace);
  }

  return text + "...";
};

export const translit = function (text) {
  return text
    .replace(
      /([а-яё])|([\s_-])|([^a-z\d])/gi,
      function (all, ch, space, words) {
        if (space || words) {
          return space ? "-" : "";
        }
        let code = ch.charCodeAt(0),
          index =
            code === 1025 || code === 1105
              ? 0
              : code > 1071
              ? code - 1071
              : code - 1039,
          t = [
            "yo",
            "a",
            "b",
            "v",
            "g",
            "d",
            "e",
            "zh",
            "z",
            "i",
            "y",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "r",
            "s",
            "t",
            "u",
            "f",
            "h",
            "c",
            "ch",
            "sh",
            "shch",
            "",
            "y",
            "",
            "e",
            "yu",
            "ya",
          ];
        return t[index];
      }
    )
    .toLowerCase();
};
